// extracted by mini-css-extract-plugin
export default {"root":"ActionsBarCenter_root__UaPBZ"};